import { Component, Input, OnInit,  OnDestroy, Output, EventEmitter } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-carrentextrafilters',
    templateUrl: './carrentextrafilters.component.html',
    styleUrls: ['./carrentextrafilters.component.scss'],
    standalone: false
})
export class CarrentextrafiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
    protected unsubscribe$ = new Subject();
    desktopTemplate: string = 'xl';

    showSmallMode: boolean = false;
    loading: boolean = false;
    filtersData: CarrentFilters;

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected trafficsService: TrafficsService,
        protected carrentFiltersService: CarrentFiltersService
    ) { }

    ngOnInit(): void {
        this.initMedia();
        this.getFilters();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initMedia(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
    }

    getFilters(): void {
        this.carrentFiltersService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(params => {
            if (params) {
                const tmp = JSON.parse(JSON.stringify(params));
                for (let i = 0; i < tmp?.filters?.opi?.filterList?.length; i++) {
                    if(tmp.filters.opi.filterList[i].code === 'FTI' || tmp.filters.opi.filterList[i].code === 'CFTI') {
                        tmp.filters.opi.filterList.splice(i, 1);
                        i--;
                    }
                    
                }
                this.filtersData = tmp;
            }
        });
    }

    closeextras(): void {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.carrentFiltersService.resetAllExtrasHome();
    }

    setOpi(ev): void {
        this.carrentFiltersService.opiResult(ev, this.mode === 'home');
    }

    setFkl(ev): void {
        this.carrentFiltersService.fklResult(ev, this.mode === 'home');
    }

    setPkt(ev): void {
        this.carrentFiltersService.pktResult(ev, this.mode === 'home');
    }

    setFty(ev): void {
        this.carrentFiltersService.ftyResult(ev, this.mode === 'home');
    }

    setInc(ev): void {
        this.carrentFiltersService.incResult(ev, this.mode === 'home');
    }

    setIns(ev): void {
        this.carrentFiltersService.insResult(ev, this.mode === 'home');
    }

    setTrg(ev): void {
        this.carrentFiltersService.trgResult(ev, this.mode === 'home');
    }
}
